/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finals_Finish_Hint_Not_ReadyInputs */



/**
* | output |
* | --- |
* | "Finals table must be Finished first" |
*
* @param {Finals_Finish_Hint_Not_ReadyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finals_finish_hint_not_ready = /** @type {((inputs?: Finals_Finish_Hint_Not_ReadyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finals_Finish_Hint_Not_ReadyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La table de finale doit être terminée d'abord")
	if (locale === "es") return /** @type {LocalizedString} */ ("La mesa de finales debe estar finalizada primero")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A mesa final deve estar Finalizada primeiro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tavolo finale deve essere prima Concluso")
	return /** @type {LocalizedString} */ ("Finals table must be Finished first")
});